import { writable } from 'svelte/store';
import { produce } from 'immer';
import { addChanges } from './Changes';

let ui = {
  selectedMenu: -1,
  selectedColor: 0,
  cellSize: 60,
  scrollX: 0,
  scrollY: 0,
  xStepDistance: 8,
  yStepDistance: 8,
  showTreadleOrder: true,
  showThreading: true,
  selectTo: 0,
  selectFrom: 0,
  isDragging: false,
  hoverCell: [0, 0],
  disableScroll: false,
  locale: '',
  showReloadDialog: false,
  showErrorDialog: false,
  lastException: undefined,
};

if (window.localStorage.getItem('ui')) {
  let storedUI = JSON.parse(localStorage.getItem('ui'));
  ui = { ...ui, ...storedUI };
}

const store = writable(ui);
let prevStore = ui;
store.subscribe((s) => {
  prevStore = s;
});

export default {
  ui: store,
  update: function (func) {
    store.set(produce(prevStore, func, (patches) => addChanges(patches)));
  },
  subscribe: function (subscription) {
    return store.subscribe(subscription);
  },
  showError: function (exception) {
    this.update((temp) => {
      temp.showErrorDialog = true;
      temp.lastException = exception;
    });
  },
};

window.dropUi = function () {
  localStorage.removeItem('ui');
};

store.subscribe((value) => {
  window.ui = value;
  localStorage.setItem(
    'ui',
    JSON.stringify({
      selectedColor: value.selectedColor,
      cellSize: value.cellSize,
    })
  );
});
